<div class="min-h-screen bg-gray-50 pb-24 lg:pb-0">
  <app-navbar [showBackButton]="true"></app-navbar>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="max-w-7xl mx-auto px-4 sm:px-6 py-12 text-center">
    <div class="inline-block animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-[#4A90E2]"></div>
    <p class="mt-4 text-gray-600">Carregando dados do edital...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isLoading" class="max-w-7xl mx-auto px-4 sm:px-6 py-12 text-center">
    <app-icon name="alert-circle" className="w-16 h-16 mx-auto text-red-500 mb-4"></app-icon>
    <p class="text-red-600 text-lg">{{ errorMessage }}</p>
    <a routerLink="/portal" class="inline-block mt-4 text-[#4A90E2] hover:underline">Voltar para o portal</a>
  </div>

  <!-- Content -->
  <div *ngIf="contest && !isLoading">
    <!-- Hero Section -->
    <div class="relative h-48 sm:h-56 md:h-64 bg-gradient-to-r from-[#2c5f8d] to-[#4A90E2] overflow-hidden">
      <div class="absolute inset-0 opacity-20">
        <img src="/modern-university-campus-education-building-profes.jpg" alt="Campus"
          class="w-full h-full object-cover" />
      </div>
      <div class="relative max-w-7xl mx-auto px-4 sm:px-6 h-full flex items-center">
        <div class="text-white w-full">
          <div class="mb-3 sm:mb-4">
            <span [class]="getStatusColor(contest.tag)"
              class="text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full font-semibold shrink-0 text-xs sm:text-sm">
              {{ getStatusLabel(contest.tag) }}
            </span>
          </div>
          <h1 class="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2 text-balance">
            Edital N° {{ contest.numeroEdital }} - {{ contest.nome }}
          </h1>
          <p class="text-base sm:text-lg md:text-xl text-white/95 font-medium">
            {{ contest.orgaoNome }}
          </p>
        </div>
      </div>
    </div>

    <div #mobileCta class="lg:hidden px-4 sm:px-6 mt-6">
      <div
        class="bg-gradient-to-br from-[#2c5f8d] via-[#4A90E2] to-[#5ba3ef] rounded-2xl p-6 text-white shadow-lg border border-blue-600">
        <h3 class="text-lg font-bold mb-1">{{ getRegistrationStatus().title }}</h3>
        <p class="text-white/90 mb-4 text-xs leading-relaxed">
          {{ getRegistrationStatus().description }}
        </p>
        <a [routerLink]="!getRegistrationStatus().disabled ? ['/portal/candidato/inscricao', contest.id] : null">
          <button [disabled]="getRegistrationStatus().disabled" [ngClass]="{
              'bg-white text-[#4A90E2] hover:bg-gray-100 cursor-pointer': !getRegistrationStatus().disabled,
              'bg-gray-300 text-gray-500 cursor-not-allowed': getRegistrationStatus().disabled
            }" class="w-full rounded-xl font-bold h-10 text-sm shadow-md transition-colors">
            {{ getRegistrationStatus().button }}
          </button>
        </a>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
      <div *ngIf="contest.descricao && contest.descricao.trim()"
        class="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm mb-4 sm:mb-6 border border-gray-200">
        <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
          Sobre o Processo Seletivo
        </h2>
        <p class="text-sm sm:text-base text-gray-700 leading-relaxed">{{ contest.descricao }}</p>
      </div>

      <div class="grid lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
        <!-- Main Content -->
        <div class="lg:col-span-2 space-y-4 sm:space-y-6 md:space-y-8">

          <div class="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-6">
            <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5">
              Informações Gerais
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-5">
              <div class="flex items-start gap-2 sm:gap-3 p-3 bg-blue-50 rounded-lg">
                <app-icon name="users"
                  className="w-5 h-5 sm:w-6 sm:h-6 text-[#4A90E2] shrink-0 mt-0.5 sm:mt-1"></app-icon>
                <div>
                  <p class="text-xs sm:text-sm text-gray-600 mb-1">Vagas Disponíveis</p>
                  <p class="font-bold text-gray-900 text-base sm:text-lg">{{ contest.vagasFormatadas }}</p>
                </div>
              </div>
              <!-- <div class="flex items-start gap-2 sm:gap-3 p-3 bg-blue-50 rounded-lg">
                <app-icon name="dollar-sign"
                  className="w-5 h-5 sm:w-6 sm:h-6 text-[#4A90E2] shrink-0 mt-0.5 sm:mt-1"></app-icon>
                <div>
                  <p class="text-xs sm:text-sm text-gray-600 mb-1">Taxa de Inscrição</p>
                  <p class="font-bold text-gray-900 text-base sm:text-lg">{{ getRegistrationFeeRange() }}</p>
                </div>
              </div> -->
              <div class="flex items-start gap-2 sm:gap-3 p-3 bg-blue-50 rounded-lg" *ngIf="getInscriptionStage()">
                <app-icon name="calendar"
                  className="w-5 h-5 sm:w-6 sm:h-6 text-[#4A90E2] shrink-0 mt-0.5 sm:mt-1"></app-icon>
                <div>
                  <p class="text-xs sm:text-sm text-gray-600 mb-1">Período de Inscrições</p>
                  <p class="font-bold text-gray-900 text-xs sm:text-sm">
                    {{ formatDateTime(getInscriptionStage()!.dtInicio) }} até {{
                    formatDateTime(getInscriptionStage()!.dtFim) }}
                  </p>
                </div>
              </div>
              <!-- <div class="flex items-start gap-2 sm:gap-3 p-3 bg-blue-50 rounded-lg" *ngIf="getExamStage()">
                <app-icon name="clock"
                  className="w-5 h-5 sm:w-6 sm:h-6 text-[#4A90E2] shrink-0 mt-0.5 sm:mt-1"></app-icon>
                <div>
                  <p class="text-xs sm:text-sm text-gray-600 mb-1">Data da Prova</p>
                  <p class="font-bold text-gray-900 text-xs sm:text-sm">
                    {{ formatDateTime(getExamStage()!.dtInicio) }}
                  </p>
                </div>
              </div> -->
            </div>
          </div>

          <!-- Available Positions -->
          <div class="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-gray-200 p-4 sm:p-6">
            <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 flex items-center gap-2">
              <app-icon name="briefcase" className="w-6 h-6 text-[#4A90E2]"></app-icon>
              Cargos Disponíveis
            </h2>

            <div class="space-y-4">
              <div *ngFor="let cargo of contest.cargos; let i = index"
                [ngClass]="{'hidden lg:block': i >= 3 && !showAllCargos}"
                class="border-2 border-gray-200 rounded-lg p-5 hover:border-[#4A90E2] hover:shadow-md transition-all">

                <div *ngIf="cargo.vagas === 0 && cargo.cadastroReserva === 0" class="flex items-center justify-between">
                  <div>
                    <h3 class="text-md font-bold text-gray-900">{{ cargo.nome }}</h3>
                    <p class="text-sm text-gray-600 capitalize">Nível: {{ cargo.nivel }}</p>
                  </div>
                  <div class="text-right">
                    <p class="text-sm font-bold text-gray-900 mb-1">Cadastro Reserva</p>
                    <!-- <p class="text-xs text-gray-500">Taxa de Inscrição</p>
                    <p class="text-sm font-semibold text-gray-900 mt-0.5">{{ formatCurrency(cargo.taxaInscricao) }}</p> -->
                  </div>
                </div>

                <div *ngIf="!(cargo.vagas === 0 && cargo.cadastroReserva === 0)">
                  <div class="mb-3">
                    <h3 class="text-md font-bold text-gray-900">{{ cargo.nome }}</h3>
                    <p class="text-sm text-gray-600 capitalize">Nível: {{ cargo.nivel }}</p>
                  </div>
                  
                  <div class="grid grid-cols-3 gap-2 mt-3 pt-3 border-t border-gray-200">
                    <div>
                      <p class="text-xs text-gray-500 mb-0.5">Vagas</p>
                      <p class="text-sm font-semibold text-gray-900">
                        {{ cargo.vagas > 0 ? cargo.vagas : '0' }}
                      </p>
                    </div>

                    <div class="text-center border-l border-gray-100 border-r">
                      <p class="text-xs text-gray-500 mb-0.5">Cadastro Reserva</p>
                      <p class="text-sm font-semibold text-gray-900">
                        {{ cargo.cadastroReserva > 0 ? cargo.cadastroReserva : '-' }}
                      </p>
                    </div>

                    <!-- <div class="text-right">
                      <p class="text-xs text-gray-500 mb-0.5">Taxa de Inscrição</p>
                      <p class="text-sm font-semibold text-gray-900">
                        {{ formatCurrency(cargo.taxaInscricao) }}
                      </p>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <button *ngIf="contest.cargos.length > 3"
                    (click)="showAllCargos = !showAllCargos"
                    class="w-full py-2 mt-4 text-[#4A90E2] font-semibold text-sm lg:hidden flex items-center justify-center gap-1 hover:bg-blue-50 rounded-lg transition-colors border border-transparent hover:border-blue-100">
              <span>{{ showAllCargos ? 'Ver menos cargos' : 'Ver todos os cargos (' + contest.cargos.length + ')' }}</span>
              <app-icon [name]="showAllCargos ? 'chevron-up' : 'chevron-down'" className="w-4 h-4"></app-icon>
            </button>
          </div>

          <!-- Timeline/Stages -->
          <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 class="text-xl font-bold text-gray-900 mb-4">Cronograma</h2>
            <div class="space-y-0"> <div *ngFor="let etapa of contest.etapas; let i = index; let isLast = last"
                [ngClass]="(i >= 3 && !showAllCronograma) ? 'hidden lg:flex' : 'flex'"
                class="gap-4">
                
                <div class="flex flex-col items-center">
                  <div class="w-4 h-4 rounded-full border-2 shrink-0 z-10" [ngClass]="{
                      'bg-green-500 border-green-500': isStagePast(etapa),
                      'bg-orange-500 border-orange-500': isStageActive(etapa),
                      'bg-white border-gray-300': !isStageActive(etapa) && !isStagePast(etapa)
                    }"></div>
                  
                  <div *ngIf="!isLast && (!(!showAllCronograma && i === 2) || showAllCronograma)" 
                       class="w-0.5 flex-1 -mt-1" 
                       [ngClass]="{
                         'bg-green-500': isStagePast(etapa),
                         'bg-orange-500': isStageActive(etapa),
                         'bg-gray-200': !isStageActive(etapa) && !isStagePast(etapa)
                       }"></div>
                </div>

                <div class="flex-1 pb-6"> <p class="font-bold text-gray-900">{{ getStageTypeLabel(etapa.tipo) }}</p>
                  <p class="text-sm text-gray-600">{{ formatDateTime(etapa.dtInicio) }} até {{
                    formatDateTime(etapa.dtFim) }}
                  </p>
                  <span *ngIf="isStageActive(etapa)"
                    class="inline-block mt-1 px-2 py-0.5 bg-orange-100 text-orange-700 text-xs font-medium rounded">
                    Em andamento
                  </span>
                  <span *ngIf="isStagePast(etapa)"
                    class="inline-block mt-1 px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded">
                    Concluído
                  </span>
                </div>
              </div>
            </div>

            <button *ngIf="contest.etapas.length > 3"
                    (click)="showAllCronograma = !showAllCronograma"
                    class="w-full py-2 mt-2 text-[#4A90E2] font-semibold text-sm lg:hidden flex items-center justify-center gap-1 hover:bg-blue-50 rounded-lg transition-colors border border-transparent hover:border-blue-100">
              <span>{{ showAllCronograma ? 'Ver cronograma completo' : 'Ver todo o cronograma' }}</span>
              <app-icon [name]="showAllCronograma ? 'chevron-up' : 'chevron-down'" className="w-4 h-4"></app-icon>
            </button>
          </div>

          <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 class="text-lg font-bold text-gray-900 mb-4">Documentos do Edital</h3>
            <div *ngIf="visibleDocuments.length === 0" class="text-center py-6 text-gray-500">
              <app-icon name="file-text" className="w-10 h-10 mx-auto mb-2 text-gray-300"></app-icon>
              <p class="text-sm">Nenhum documento disponível no momento.</p>
            </div>
            <div class="space-y-3" *ngIf="visibleDocuments.length > 0">
              <a *ngFor="let documento of visibleDocuments" [href]="documento.url" target="_blank"
                rel="noopener noreferrer"
                class="w-full flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-[#4A90E2] transition-all group">
                <app-icon name="file-text" className="w-5 h-5 text-[#4A90E2] mt-0.5 flex-shrink-0"></app-icon>
                <div class="flex-1 min-w-0 text-left">
                  <p class="text-sm font-medium text-gray-900 truncate group-hover:text-[#4A90E2]">
                    {{ documento.nomeArquivo }}
                  </p>
                  <p class="text-xs text-gray-600">{{ getDocumentTypeLabel(documento.tipo) }} · {{
                    formatFileSize(documento.tamanhoBytes) }}</p>
                  <p class="text-xs text-gray-500 mt-1" *ngIf="getDocumentDisplayDate(documento) as displayDate">
                    <ng-container *ngIf="documento.dataExibicaoSite">Disponibilizado em {{ formatDateTime(displayDate) }}</ng-container>
                    <ng-container *ngIf="!documento.dataExibicaoSite">Disponibilizado em {{ formatDateTime(displayDate) }}</ng-container>
                  </p>
                </div>
                <app-icon name="download"
                  className="w-4 h-4 text-[#4A90E2] flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"></app-icon>
              </a>
            </div>
          </div>

        </div>

        <div class="lg:col-span-1">
          <div class="sticky top-8 space-y-6">

            <div
              class="hidden lg:block bg-gradient-to-br from-[#2c5f8d] via-[#4A90E2] to-[#5ba3ef] rounded-2xl p-6 text-white shadow-lg border border-blue-600">
              <h3 class="text-xl font-bold mb-2">
                {{ getRegistrationStatus().title }}
              </h3>
              <p class="text-white/95 mb-4 text-sm leading-relaxed">
                {{ getRegistrationStatus().description }}
              </p>
              <a [routerLink]="!getRegistrationStatus().disabled ? ['/portal/candidato/inscricao', contest.id] : null">
                <button [disabled]="getRegistrationStatus().disabled" [ngClass]="{
                    'bg-white text-[#4A90E2] hover:bg-gray-100 cursor-pointer': !getRegistrationStatus().disabled,
                    'bg-gray-300 text-gray-500 cursor-not-allowed': getRegistrationStatus().disabled
                  }" class="w-full rounded-2xl font-bold h-12 text-base shadow-md transition-colors">
                  {{ getRegistrationStatus().button }}
                </button>
              </a>
              <p class="text-xs text-white/80 mt-3 text-center">
                Processo 100% online e seguro
              </p>
            </div>

            <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
              <h3 class="text-lg font-bold text-gray-900 mb-4">Status do Edital</h3>
              <div class="space-y-3 text-sm">
                <div class="flex items-start gap-3">
                  <app-icon name="calendar" className="w-5 h-5 text-[#4A90E2]"></app-icon>
                  <div>
                    <p class="text-gray-600">Publicado em</p>
                    <p class="font-medium text-gray-900">{{ formatDate(contest.dtPublicacao) }}</p>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <app-icon name="activity" className="w-5 h-5 text-[#4A90E2]"></app-icon>
                  <div>
                    <p class="text-gray-600">Etapa Atual</p>
                    <p class="font-medium text-gray-900">{{ contest.etapaAtualDescricao }}</p>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <app-icon name="hash" className="w-5 h-5 text-[#4A90E2]"></app-icon>
                  <div>
                    <p class="text-gray-600">Número do Edital</p>
                    <p class="font-medium text-gray-900">{{ contest.numeroEdital }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!getRegistrationStatus().disabled"
      class="fixed bottom-0 left-0 right-0 z-50 p-4 lg:hidden transition-transform duration-300 ease-in-out shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] bg-gradient-to-br from-[#2c5f8d] via-[#4A90E2] to-[#5ba3ef]"
      [ngClass]="showStickyButton ? 'translate-y-0' : 'translate-y-full'">
      <div class="flex items-center justify-between gap-4 max-w-7xl mx-auto">
        <div class="text-white hidden sm:block">
          <p class="font-bold text-sm">{{ getRegistrationStatus().title }}</p>
          <p class="text-xs text-white/90">Não perca o prazo!</p>
        </div>
        <a [routerLink]="['/portal/candidato/inscricao', contest.id]" class="w-full sm:w-auto">
          <button
            class="w-full sm:w-auto px-6 py-3 rounded-xl font-bold text-sm shadow-md transition-colors bg-white text-[#4A90E2] hover:bg-gray-100">
            {{ getRegistrationStatus().button }}
          </button>
        </a>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</div>